import { isLocalMocks } from "library/api/api";
import { Action, ActionType, PageType, State } from "../types";

export const handleOtp = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.OTP_SUBMITTED_SUCCESSFULLY: {
      return {
        ...state,
        page: PageType.LANDING,
        ...(isLocalMocks
          ? {
              sessionExpiry: Date.now() + 10 * 60 * 1000, // 10 minutes from now
            }
          : {}),
      };
    }

    case ActionType.OTP_SUBMISSION_FAILED:
    case ActionType.OTP_RESEND_FAILED: {
      return {
        ...state,
        page: PageType.ERROR,
      };
    }

    default: {
      return state;
    }
  }
};
